import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useArchiveEventMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();

  return useMutation({
    mutationFn: async (eventId) => {
      const archiveEvent = api.archiveEvent;
      if (!archiveEvent) {
        throw new Error('Archive is not available for this account');
      }

      const result = await archiveEvent(eventId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to archive event');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    ...options,
  });
};
